import React from "react";
import { Card } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";

const CustomCard = ({ title, image, channelTitle, publishedAt }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  return (
    <Card className="custom-result-card h-100 border-0 shadow-sm hover-effect">
      <div className="card-img-wrapper">
        <Card.Img
            variant="top"
            src={image}
            className="card-img-top"
            alt={title}
            loading="lazy"
        />
      </div>
      <Card.Body className="d-flex flex-column">
        <Card.Title className="card-title-clamp mb-2" title={title}>
            {title}
        </Card.Title>
        <div className="mt-auto">
            <div className="d-flex align-items-center text-muted small mb-1">
                <FaUserCircle className="me-1" />
                <span className="text-truncate">{channelTitle}</span>
            </div>
            {publishedAt && (
                <div className="text-muted small">
                    {formatDate(publishedAt)}
                </div>
            )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default CustomCard;
